import UtilityMixin from "./UtilityMixin";
export const Permessi = { LETTURA: 1, INSERIMENTO: 2, MODIFICA: 4, CANCELLAZIONE: 8, STAMPA: 16, DOWNLOAD: 32, FIRMA: 64 };
export default {
	mixins: [UtilityMixin],
	data() {
		return {
			Permessi: { LETTURA: 1, INSERIMENTO: 2, MODIFICA: 4, CANCELLAZIONE: 8, STAMPA: 16, DOWNLOAD: 32, FIRMA: 64 },
		};
	},
	methods: {
		verificaPermesso(idSezione, idRisorsa, permessoDaVerificare, verificaPermessiSuccess, verificaPermessiError) {
			let pathResources = "/condivisione/verificapermesso";
			let returnValue = false;
			let sessionStorage = window.sessionStorage;
			let user = sessionStorage.getItem("user");
			if (user) {
				user = JSON.parse(user);
				let permessi = user.permessi.filter((e) => e.id === idSezione);
				if (permessi.length > 0) {
					permessi[0].permessi.filter((e) => e.permesso === permessoDaVerificare);
					let permesso = permessi[0].permessi.find((obj) => {
						return obj.permesso === permessoDaVerificare;
					});
					returnValue = permesso ? permesso.attivo : false;
				}
			}
			if (!returnValue) {
				UtilityMixin.methods.loadDataResources(pathResources, { idRisorsa: idRisorsa, permesso: permessoDaVerificare }, verificaPermessiSuccess, verificaPermessiError);
			}

			//return returnValue;
		},
	},
};
